
import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";
import Vue from "vue";
const apiService = new ApiService(Vue.prototype.$config.authenticationBaseAddress);

 const Hotel = {
    VOUCHER_URL: "HotelRoom/GetVoucherById",
};
const factory = () => ({
 
});

export default {
    namespaced: true,
    state: factory(),
    mutations: {
    
    },

    getters: {
  
    },

    actions: {

        async GetVoucher(context, params) {
            const response = await apiService.Post(Hotel.VOUCHER_URL, params);

            return response.data.data;
        },
       

    }
}